import { useContext, useMemo } from "react";
import { AuthContext } from "../context/AuthContext";

export function useCanViewApiAudit() {
  const { userData } = useContext(AuthContext);
  return useMemo(() => {
    if (Number(userData?.master) === 1) return true;
    const scope = userData?.scope;
    // Alinhado a isApiAuditViewer no backend (event.userMaster / scope platform).
    // Parceiro no tenant opera com master=1 no JWT de workspace, mas o login do portal
    // pode deixar master=0 no userData — scope partner indica o mesmo privilégio no chat.
    if (scope === "platform" || scope === "partner") return true;
    return false;
  }, [userData?.master, userData?.scope]);
}
